// Supported UI languages.
export type LangCode = 'ru' | 'en' | 'pl' | 'de';

export const LANGS: { code: LangCode; label: string }[] = [
  { code: 'ru', label: 'RU' },
  { code: 'en', label: 'EN' },
  { code: 'pl', label: 'PL' },
  { code: 'de', label: 'DE' },
];

// Fallback when neither stored preference nor browser language match.
export const DEFAULT_LANG: LangCode = 'en';
